import css from 'styled-jsx/css'
import { colors } from 'theme'

export const listElementsStyles = css`
  .list-elements {
    background-color: ${colors.white};
    position: relative;
  }
  .list-elements.loading {
    min-height: 5rem;
  }
  .list-elements.loading .loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .list-elements.loading .loading:hover {
    cursor: wait;
  }
  .list-elements.loading .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list-elements.loading .loading-effect {
    transition: 0.3s;
    animation: apper 0.2s forwards;
    background-color: ${colors.white};
    opacity: 0.6;
    filter: blur(3px);
  }
  .list-elements.loading .spinner {
    top: 12%;
    display: flex;
    justify-content: center;
  }

  @keyframes apper {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.6;
    }
  }

  .wrapper-elements .element {
    border: 1px solid transparent;
    transition: all 0.2s;
    border-top: 1px solid ${colors.border};
  }

  .wrapper-elements .element:last-child {
    border-bottom: 1px solid ${colors.border};
  }

  .wrapper-elements .element:hover {
    background-color: ${colors.lightGray};
  }
  .wrapper-elements .element.empty-element {
    padding: 1rem;
  }
`
